// extracted by mini-css-extract-plugin
export default {"mainContainer":"emptyBellAlertList_mainContainer__wNtpR","contentBox":"emptyBellAlertList_contentBox__JVC4q","text":"emptyBellAlertList_text__DDugR"};